// Whitelist of allowed AI profile IDs for Stories tab recommendations
const allowUserList = [
    "d94e4b32-78b2-4ed3-bf5c-83f5c8f19f08",
    "c9ad638d-0080-4a4f-aa92-e614b88307ac",
    "c0d80aab-23a7-4ee9-b928-f8e5aab6f0b2",
    "b6d3c661-226b-4f40-b6e0-c17c864c9f26",
    "b519fa3d-98e0-4c5d-92e4-d7a4b15b3a7b",
    "b4c5bde4-cf4b-4d60-8d5a-78cd3a7142fa",
    "b22d9127-929c-4ff7-b8bb-f25654302db2",
    "aa2ee261-84d0-4ecb-8b7d-36ec9b77cf2a",
    "a9dc1c63-8fb3-4ff7-b20e-1f3e84a44412",
    "a8144a5c-67a4-42df-b75c-7ddf6fdf7f9f",
    "a7b9f124-83cb-46d8-9e49-69d57e3c3d55",
    "a6edc1c1-8d22-4dc0-af0f-92b9b72cd501",
    "a246f8e3-7c65-4b70-89c3-d9e9e567d8c2",
    "a014bb35-629b-4e21-99cb-82014b98a721",
    "9233e21e-4799-438a-9ad2-29ad39bfc2d0",
    "9107d1df-f3a3-4bb4-8a1d-9a5b8b55a10a",
    "8eeec28d-96a8-48d9-8473-bceca46f23f1",
    "7f73ce65-3a64-42fa-9c0a-2f908a6a50ee",
    "78e019c9-b66b-469b-86d5-bb72725bcd01",
    "5bc83bda-dcb7-4a8f-90f7-801f3ff54897",
    "5a83d947-24c0-4453-9ee0-0b2b9c5e0d3d",
    "4f7cb36d-1b65-47ee-a21d-b930c0e8b8af",
    "4d62cb5b-1747-4e65-a3ee-f351c79d22c7",
    "36f82bc5-1a84-4b19-bd6d-87db2f7ad914",
    "34f8e8c7-b103-47c8-9f1c-9f5092e9e29b",
    "32d7fbd0-8d6d-45f5-8f58-8f79e734efc3",
    "27e73d72-7c15-4a1b-b4e0-ffb96df6cba2",
    "21b7e2c1-bb4a-4f4d-9b73-1c69c17b812a",
    "1a68a515-7686-4a84-8b5a-1b4af05d9f4c",
    "14e7f9b4-fb6b-4490-8bcb-8f5acfe1b4c1",
    "11c8b54a-68d2-47da-9d8a-d9ac22e16d7e",
    "0f41b9c9-58bb-4a04-aec6-dfba418c1422",
    "0a9a3deb-b3ec-4f03-aa6c-4a048a7e4bb1",
    "01a1a5ac-8cdf-4456-b514-e255f0e60f6d"
]

export default allowUserList